<template>
    <input type="hidden" name="_token" :value="csrf">
</template>

<script type = "text/javascript">

    export default {
        beforeMount(){
            this.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
    }
</script>
<style>
</style>
